import { socket } from '../..';
import { store } from '@shared/redux';
import { generatedApi } from '@shared/api';
import { notify } from '@app/providers/notification/notification';
import i18n from '@shared/services/i18n/i18n';

export const handleChannelDeactivated = () => {
  return socket.onMessage('CHANNEL_DEACTIVATED', async (payload) => {
    const channelId = payload.channel_id;
    const channelName = payload.channel_name;
    const isActive = payload.is_active;
    const reason = payload.reason;

    notify({
      message: i18n.t('channels.channelDeactivated.title', {
        channel: channelName,
      }),
      description: i18n.t('channels.channelDeactivated.message', {
        reason: reason,
      }),
    });

    const getChannelListArgs = generatedApi.util.selectCachedArgsForQuery(
      store.getState(),
      'getChannelListChannelListGet',
    );

    for (const args of getChannelListArgs) {
      store.dispatch(
        generatedApi.util.updateQueryData('getChannelListChannelListGet', args, (draft) => {
          const channel = draft.find((item) => item.id === channelId);
          if (channel) {
            channel.is_active = isActive;
          }
        }),
      );
    }
  });
};
